import { render, staticRenderFns } from "./menu_edition_matieres.vue?vue&type=template&id=bbe9a48e"
import script from "./menu_edition_matieres.js?vue&type=script&lang=js&external"
export * from "./menu_edition_matieres.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports